import { request } from '@umijs/max';
import {
  ComputedBillTotalAmountParamsType,
  paymentBillParamsType,
  PaymentBillRequestType,
} from '@/pages/PaymentBill/interface';
import { RequestType } from '@/interface';

export const queryPaymentBillList = async (data: paymentBillParamsType) => {
  return request('/api/property/PropertyOrder/getList', {
    method: 'POST',
    data,
  });
};

/**
 * 查询优惠金额
 * @param data
 */
export const queryDiscount = async (data: any) => {
  return request('/api/property/discount/discount/amount', {
    method: 'POST',
    data,
  });
};

/**
 * 提交支付
 * @param data
 */
export const queryWechatPayment = async (data: any) => {
  return request('/api/property/payment/administration/payment', {
    method: 'POST',
    data,
  });
};

/**
 * 查询客户待缴费账单列表
 * @param params
 */
export const queryCustomerPaymentBillList = async (params: {
  customerId?: string;
  roomId?: string;
}) =>
  request<Promise<RequestType<PaymentBillRequestType>>>(
    '/api/community/charge/bill/list/paymenthall',
    {
      method: 'GET',
      params,
    },
  );

/**
 * 查询客户账单详情
 * @param billNo
 */
export const queryCustomerBillDetail = async (billNo: string) =>
  request(`/api/community/charge/bill/${billNo}`, {
    method: 'GET',
  });

/**
 * 计算客户账单总金额
 * @param data
 */
export const queryComputedPaymentBillTotalAmount = async (
  data: Partial<ComputedBillTotalAmountParamsType>,
) =>
  request('/api/community/charge/bill/payment/cal', {
    method: 'POST',
    data,
  });

/**
 * 提交客户支付
 * @param data
 */
export const queryPayment = async (data: any) =>
  request('/api/community/trade/payment', {
    method: 'POST',
    data,
  });
